import {APP_INITIALIZER, ApplicationConfig, importProvidersFrom, LOCALE_ID, isDevMode} from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
} from '@angular/router';
import { appRoutes } from './app.routes';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import {  provideAuth } from '@dabnet-kamu/libs/auth';
import {  provideHttpClient,  withInterceptorsFromDi,withInterceptors } from '@angular/common/http';
import { provideAppSettings, SurumGuncellemeService } from '@dabnet-kamu/libs/ui';
import { registerLocaleData } from '@angular/common';
import localeTr from '@angular/common/locales/tr'
import {FontAwesomeModule, FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { provideServiceWorker } from '@angular/service-worker';
import {DEFAULT_INTERRUPTSOURCES, Idle, IdleExpiry, provideNgIdle, LocalStorage, LocalStorageExpiry} from "@ng-idle/core";
import { Keepalive } from '@ng-idle/keepalive';

registerLocaleData(localeTr, 'tr');

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'tr' },
    provideAppSettings(),
    provideAuth(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideToastr(),
    provideAnimations(),
    importProvidersFrom(FontAwesomeModule),
    provideServiceWorker('sw.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
    }),
    // Yeni sürüm uyarısı (05.10.2026): açılışta başlar, 15 dk'da bir kontrol eder (bkz. SurumGuncellemeService)
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [SurumGuncellemeService],
      useFactory: (s: SurumGuncellemeService) => () => s.baslat(),
    },
    provideNgIdle(),
    Keepalive,
    LocalStorage,
    Idle,
    {
      provide: IdleExpiry,
      useClass: LocalStorageExpiry
    },
    {
      provide: DEFAULT_INTERRUPTSOURCES,
      useValue: DEFAULT_INTERRUPTSOURCES
    }
],
};

